<section class="modal-window">
  <header>
    <h3>{{data.title}}</h3>
  </header>
  <div class="mw-body">
        <mat-icon aria-hidden="false" [ngClass]="{
            'confirm' : data.icon==='info',
            'info' : data.icon==='info',
            'wait' : data.icon==='warning',
            'warn' : data.icon==='warning',
            'error': data.icon==='error'}">
      {{data.icon}}
    </mat-icon>
    <div>
      <p [innerHTML]="data.body|safeHtml"></p>
      @if (data.type==='wait') {
        <div class="spinner-wait-container">
          <mat-spinner color="primary" class="spinner-wait" diameter="48"></mat-spinner>
        </div>
      }
    </div>
  </div>

  <footer mat-dialog-actions>
    @switch (data.type) {
      @case ('confirm') {
        <div class="">
          <button mat-raised-button color="primary" mat-dialog-close><span i18n>Cancelar</span></button>
          <button mat-raised-button color='primary' (click)="closeAndReturn('true')"><span i18n>Aceptar</span></button>
        </div>
      }
      @case ('wait') {
        <div class="">
        </div>
      }
      @default {
        <button mat-raised-button color='primary' (click)="close()"><span i18n>Continuar</span></button>
      }
      <!-- <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button> -->
    }
  </footer>

</section>
